"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _uiKit = require("@devsta/ui-kit");

var _lodash2 = _interopRequireDefault(require("lodash.flatten"));

var _queryString = _interopRequireDefault(require("query-string"));

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _classnames = _interopRequireDefault(require("classnames"));

var _statusMap = _interopRequireDefault(require("../../../constants/statusMap"));

var _FiltersGroup = _interopRequireDefault(require("./FiltersGroup"));

require("../styles/_filters.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DEFAULT_FILTERS = {
  USER: [{
    label: 'Created by Me',
    value: 'ME',
    selectedDefault: true
  }, {
    label: 'Created by Everyone',
    value: 'ALL'
  }],
  STATUS: [{
    label: 'All Videos',
    value: 'ALL',
    selectedDefault: true
  }, {
    label: _statusMap.default.DRAFT,
    value: 'DRAFT'
  }, {
    label: _statusMap.default.PENDING_MASTER,
    value: 'PENDING_MASTER'
  }, {
    label: _statusMap.default.EDITING,
    value: 'EDITING,INTERNAL_REVIEW'
  }, {
    label: _statusMap.default.PENDING_REVIEW,
    value: 'PENDING_REVIEW'
  }, {
    label: _statusMap.default.APPROVED,
    value: 'APPROVED'
  }, {
    label: _statusMap.default.ON_HOLD,
    value: 'ON_HOLD'
  }]
};

var Filters = /*#__PURE__*/function (_Component) {
  _inherits(Filters, _Component);

  var _super = _createSuper(Filters);

  function Filters(props) {
    var _this;

    _classCallCheck(this, Filters);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleUpdatedUrlParams", function () {
      _this.setState({
        selectedFilters: _this.getUrlFilters()
      }, function () {
        var onUpdateFilters = _this.props.onUpdateFilters;
        var selectedFilters = _this.state.selectedFilters;
        onUpdateFilters(selectedFilters);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFacetsGroupChange", (0, _lodash.default)(function (groupName) {
      return function (facets) {
        var updatedFilter = _defineProperty({}, groupName, facets);

        var _this$props = _this.props,
            history = _this$props.history,
            location = _this$props.location;
        var selectedFilters = _this.state.selectedFilters;

        var updatedFilters = _objectSpread({}, selectedFilters, {}, updatedFilter);

        var queryParams = Object.keys(updatedFilters).reduce(function (updatedQueryParams, key) {
          var paramsArray = (0, _lodash2.default)(updatedFilters[key].map(function (value) {
            if (value === null) {
              return 'null';
            }

            if (value.includes(',')) {
              return value.split(',');
            }

            return value;
          }));
          return paramsArray.length ? _objectSpread({}, updatedQueryParams, _defineProperty({}, key, paramsArray)) : updatedQueryParams;
        }, {});
        history.replace("".concat(location.pathname, "?").concat(_queryString.default.stringify(queryParams, {
          arrayFormat: 'comma'
        })));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "resetFilters", function () {
      var _this$props2 = _this.props,
          history = _this$props2.history,
          location = _this$props2.location;
      history.replace("".concat(location.pathname));
    });

    _defineProperty(_assertThisInitialized(_this), "getUrlFilters", function () {
      var urlParams = _this.props.urlParams;

      var queryParams = _queryString.default.parse(urlParams, {
        arrayFormat: 'comma'
      });

      return Object.keys(queryParams).reduce(function (filtersObj, key) {
        var paramsArray = Array.isArray(queryParams[key]) ? queryParams[key] : [queryParams[key]];
        return _objectSpread({}, filtersObj, _defineProperty({}, key, paramsArray.map(function (value) {
          return value === 'null' ? null : value;
        })));
      }, {});
    });

    _this.state = {
      selectedFilters: _this.getUrlFilters()
    };
    return _this;
  }

  _createClass(Filters, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onUpdateFilters = this.props.onUpdateFilters;
      var selectedFilters = this.state.selectedFilters;
      onUpdateFilters(selectedFilters);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevUrlparams = _ref.urlParams;
      var urlParams = this.props.urlParams;

      if (prevUrlparams === urlParams) {
        return;
      }

      this.handleUpdatedUrlParams();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          numResults = _this$props3.numResults,
          stats = _this$props3.stats,
          containerSize = _this$props3.containerSize,
          _this$props3$filters = _this$props3.filters,
          filters = _this$props3$filters === void 0 ? DEFAULT_FILTERS : _this$props3$filters,
          _this$props3$resource = _this$props3.resourceType,
          resourceType = _this$props3$resource === void 0 ? 'video' : _this$props3$resource;
      var selectedFilters = this.state.selectedFilters;
      var isMedium = containerSize.width < _vars.NUMERIC_MEDIA_SIZES.medium;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('video-filters', {
            'video-filters--medium': isMedium
          })
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "video-filters__header"
        }, /*#__PURE__*/_react.default.createElement("p", null, "Showing"), /*#__PURE__*/_react.default.createElement("p", null, numResults || 0, ' of ', stats ? stats.global.total : '   ', " ".concat(resourceType.toLowerCase(), "s")), /*#__PURE__*/_react.default.createElement(_uiKit.LinkButton, {
          className: "video-filters__header__reset",
          onClick: this.resetFilters
        }, "RESET FILTERS")), Object.keys(filters).map(function (key) {
          return (/*#__PURE__*/_react.default.createElement(_FiltersGroup.default, {
              startClosed: isMedium,
              stats: stats,
              key: key,
              name: key,
              onChange: _this2.onFacetsGroupChange(key),
              filterFacets: filters[key],
              selectedValues: selectedFilters[key]
            })
          );
        }))
      );
    }
  }]);

  return Filters;
}(_react.Component);

var _default = Filters;
exports.default = _default;